import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Lock, User, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import client, { formatApiError } from "@/lib/api";
import { AuthShell, Field } from "@/pages/Login";

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const { lang, t } = useLang();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error(t("pw_min6")); return; }
    setLoading(true);
    try {
      await register(email.trim(), password, name.trim() || "Learner");
      // persist the interface language chosen before login so the whole app + content base follows it
      try { await client.put("/profile", { app_lang: lang }); } catch (_) { /* non-blocking */ }
      toast.success(t("account_created"));
      nav("/choose-language");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || t("signup_failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("create_account")} subtitle={t("start_speaking") + "."}>
      <form onSubmit={submit} className="space-y-4">
        <Field icon={User} type="text" placeholder={t("name_ph")} value={name}
          onChange={(e) => setName(e.target.value)} data-testid="register-name" />
        <Field icon={Mail} type="email" required placeholder={t("email_ph")} value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="register-email" />
        <Field icon={Lock} type="password" required placeholder={t("password_ph")} value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="register-password" />
        <button disabled={loading} data-testid="register-submit"
          className="w-full mel-gradient text-white font-semibold py-4 rounded-2xl shadow-[0_14px_34px_-14px_rgba(37,99,235,0.8)] flex items-center justify-center gap-2 disabled:opacity-60 press">
          {loading ? t("saving_word") : <>{t("create_account")} <ArrowRight size={18} /></>}
        </button>
      </form>
      <p className="text-center text-slate-400 mt-8">
        {t("already_have")} <Link to="/login" className="text-cyan-300 font-semibold" data-testid="to-login">{t("log_in")}</Link>
      </p>
    </AuthShell>
  );
}
